import { defineStore } from 'pinia'

export const useRegistrationModalStore = defineStore('registrationModal', {
    state: () => ({
        scrollBehaviorEnabled: false,
        footerModal: true,
    }),
})
